module.exports = __webpack_public_path__ + "img/stop.354c5abd.png";